import { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import { useAuthz } from "context/AuthzContext";
import { listVatCorrections, approveVatCorrection } from "services/tenantUserAdminService";

export default function AiFeedbackReview() {
  const { tenantId, isSuperAdmin } = useAuthz();
  const [selectedTenant, setSelectedTenant] = useState(isSuperAdmin ? "" : tenantId);
  const [clientId, setClientId] = useState("");
  const [period, setPeriod] = useState("");
  const [corrections, setCorrections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true); setError(null);
    try {
      const res = await listVatCorrections(selectedTenant, clientId, period, { approvedOnly: false, limit: 500 });
      setCorrections(Array.isArray(res) ? res : res.corrections || []);
    } catch (e) { setError(e.message || String(e)); }
    setLoading(false);
  };

  const doApprove = async (id) => {
    try {
      await approveVatCorrection(selectedTenant, clientId, period, id);
      await load();
    } catch (e) { setError(e.message || String(e)); }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <VuiBox mb={2} display="flex" justifyContent="space-between" alignItems="center">
        <VuiTypography variant="h4">AI Corrections Review</VuiTypography>
      </VuiBox>

      <Card sx={{ p: 2, mb: 2 }}>
        <VuiBox display="flex" gap={2} mb={2}>
          <TextField label="Tenant ID" size="small" value={selectedTenant} onChange={(e) => setSelectedTenant(e.target.value)} disabled={!isSuperAdmin} />
          <TextField label="Client ID" size="small" value={clientId} onChange={(e) => setClientId(e.target.value)} />
          <TextField label="Period" size="small" value={period} onChange={(e) => setPeriod(e.target.value)} />
          <VuiButton onClick={load} color="info">Load</VuiButton>
        </VuiBox>

        {error && <VuiTypography color="error">{error}</VuiTypography>}

        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>When</TableCell>
                <TableCell>User</TableCell>
                <TableCell>Box</TableCell>
                <TableCell>Suggested</TableCell>
                <TableCell>Corrected</TableCell>
                <TableCell>Approved</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {corrections.map(c => (
                <TableRow key={c.id}>
                  <TableCell>{new Date(c.createdAt || c.created_at).toLocaleString()}</TableCell>
                  <TableCell>{c.recordedBy || '—'}</TableCell>
                  <TableCell>{c.correction?.box || '—'}</TableCell>
                  <TableCell>{c.correction?.suggested || JSON.stringify(c.correction || {})}</TableCell>
                  <TableCell>{c.correction?.corrected || '—'}</TableCell>
                  <TableCell>{c.approved ? 'Yes' : 'No'}</TableCell>
                  <TableCell>
                    {!c.approved && <VuiButton size="small" color="success" onClick={() => doApprove(c.id)}>Approve</VuiButton>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      <Footer />
    </DashboardLayout>
  );
}
